export default "__VITE_ASSET__CWk2zTvP__"